<template>
  <nav class="navbar navbar-expand-md fixed-top" :class="{ 'scrolled': isScrolled }">
    <div class="container-fluid p-0">
      <router-link class="navbar-brand" @click="closeNavbar" to="/">
        <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/logo_250px.webp" alt="English Matters" width="180px">
      </router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link class="nav-link" @click="closeNavbar" to="/">
              {{ $t('navbar.home') }}
            </router-link>
          </li>
          <li class="nav-item dropdown d-flex">
            <router-link class="nav-link" @click="closeNavbar" to="/our-programs" style="padding-right: 0 !important;">
              {{ $t('navbar.ourPrograms') }}
            </router-link>
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"></a>
            <ul class="dropdown-menu">
              <li>
                <router-link class="nav-link" @click="closeNavbar" to="/our-programs">
                  {{ $t('navbar.newLanguageOfferings') }}
                </router-link>
              </li>
              <li>
                <router-link class="nav-link" @click="closeNavbar" to="/our-programs">
                  {{ $t('navbar.personalDevelopmentProgram') }}
                </router-link>
              </li>
              <li>
                <router-link class="nav-link" @click="closeNavbar" to="/our-programs">
                  {{ $t('navbar.hybridIgcseProgram') }}
                </router-link>
              </li>
              <li>
                <router-link class="nav-link" @click="closeNavbar" to="/our-programs">
                  {{ $t('navbar.schoolHolidayCamps') }}
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown d-flex">
            <router-link class="nav-link" @click="closeNavbar" to="/english-classes" style="padding-right: 0 !important;">
              {{ $t('navbar.englishClasses') }}
            </router-link>
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"></a>
            <ul class="dropdown-menu">
              <li>
                <router-link class="nav-link" @click="closeNavbar" to="/english-classes/english-class-for-5-11-years-old-kids/">
                  {{ $t('navbar.ages5') }}
                </router-link>
              </li>
              <li>
                <router-link class="nav-link" @click="closeNavbar" to="/english-classes/english-class-for-12-19-years-old-kids/">
                  {{ $t('navbar.ages12') }}
                </router-link>
              </li>
              <li>
                <router-link class="nav-link" @click="closeNavbar" to="/english-classes/english-class-for-adults/">
                  {{ $t('navbar.adults') }}
                </router-link>
              </li>
              <li>
                <router-link class="nav-link" @click="closeNavbar" to="/english-classes/school-holidays-english-class/">
                  {{ $t('navbar.creativeWritingClasses') }}
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" @click="closeNavbar" to="/english-classes/cambridge-english-exams-in-petaling-jaya/">
              {{ $t('navbar.exams') }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" @click="closeNavbar" to="/about-english-matters">
              {{ $t('navbar.aboutUs') }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" @click="closeNavbar" to="/why-us">
              {{ $t('navbar.whyUs') }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" @click="closeNavbar" to="/contact">
              {{ $t('navbar.contact') }}
            </router-link>
          </li>
          <li class="nav-item d-flex align-items-center me-4">
            <img @click="switchLang('en')" 
                  src="https://english-matters.s3.ap-southeast-1.amazonaws.com/icons/locale_en.webp" 
                  alt="English version"
                  height="20px"
                  class="me-2">
            <img @click="switchLang('cn')" 
                  src="https://english-matters.s3.ap-southeast-1.amazonaws.com/icons/locale_cn.webp" 
                  alt="Chinese version"
                  height="20px">
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped>
  .navbar-toggler {
    border: none;
  }

  .navbar-toggler-icon {
    filter: invert(1);
  }
  .navbar {
    background-color: transparent;
    transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  }

  /* Navbar after scrolling 30vh */
  .navbar.scrolled {
    background-color: #2e1aaf;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  .navbar .collapse.show, .navbar .collapsing {
    background-color: #2e1aaf !important;
  }
  a {
    color: white; 
    font-family: "Red Hat Display", sans-serif;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  a.router-link-active, a:hover {
    color: #FEB832;
  }
  ul.dropdown-menu li a.nav-link {
    color: black;
  }

  .dropdown:hover .dropdown-menu {
    display: block;
    margin-top: 2em;
  }
</style>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { Collapse } from "bootstrap"; // Import Bootstrap Collapse
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

const switchLang = (lang) => {
  locale.value = lang
  localStorage.setItem('locale', lang) // Save the choice
}

const isScrolled = ref(false);

const handleScroll = () => {
  isScrolled.value = window.scrollY > (window.innerHeight * 0.1);
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const closeNavbar = () => {
  const navbar = document.getElementById("navbarNav");
  if (window.innerWidth < 992) {
    const bsCollapse = Collapse.getInstance(navbar) || new Collapse(navbar, { toggle: false });
    bsCollapse.toggle(); // Toggle instead of just hiding
  }
};
</script>